import PropTypes from 'prop-types';

const LINK_CLASS = 'text-primary-600 underline hover:text-primary-700';

const SelectAllInFilterBanner = ({
	selectAllInFilter,
	canSelectAllInFilter,
	pageCount,
	totalCount,
	isFiltered,
	entityLabelPlural,
	onSelectAllInFilter,
	onClear,
}) => {
	if (!selectAllInFilter && !canSelectAllInFilter) return null;

	const entities = `${totalCount.toLocaleString('de-DE')} ${isFiltered ? 'gefilterten ' : ''}${entityLabelPlural}`;

	return (
		<div className="mb-3 flex flex-wrap items-center gap-3 rounded-lg bg-primary-100 px-3 py-2 text-sm text-text">
			{selectAllInFilter ? (
				<>
					<span className="font-medium text-primary-700">Alle {entities} sind ausgewählt.</span>
					<button type="button" onClick={onClear} className={LINK_CLASS}>
						Auswahl aufheben
					</button>
				</>
			) : (
				<>
					<span>
						Alle {pageCount} {entityLabelPlural} dieser Seite sind ausgewählt.
					</span>
					<button type="button" onClick={onSelectAllInFilter} className={LINK_CLASS}>
						Alle {entities} auswählen
					</button>
				</>
			)}
		</div>
	);
};

export const scopeBannerPropTypes = {
	selectAllInFilter: PropTypes.bool.isRequired,
	canSelectAllInFilter: PropTypes.bool.isRequired,
	pageCount: PropTypes.number.isRequired,
	totalCount: PropTypes.number.isRequired,
	isFiltered: PropTypes.bool.isRequired,
	entityLabelPlural: PropTypes.string.isRequired,
	onSelectAllInFilter: PropTypes.func.isRequired,
	onClear: PropTypes.func.isRequired,
};

SelectAllInFilterBanner.propTypes = scopeBannerPropTypes;

export default SelectAllInFilterBanner;
